import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { User } from "../_models/user";

export interface UserProfile {
    type: string;
    id: string;
    attributes: {
        field_nombre: string;
        field_field_apellidos: string;
        field_entidad: string;
        field_departamento: string;
    }
    relationships: {
        field_imagen: {
            data: {
                id: string;
                type: string;
            },
            links: {
                related: {
                    href: string;
                },
            }
        }
    }
};

export interface UserImage {
    id: string;
    type: string;
    url: string;
}

@Injectable()
export class UserProfileService {

    constructor(
        private http: HttpClient
    ) { }

    getUserProfile(userId: number) {
        return new Promise<UserProfile>((resolve, reject) => {
            const params = {
                'filter[drupal_internal__uid]': userId
            }
            this.http.get(environment.drupal.apiBaseUrl + '/jsonapi/user/user', { params }).subscribe({
                next: (response: any) => {
                    resolve(response.data?.[0] as UserProfile);
                },
                error: (err) => {
                    reject(err);
                }
            });
        });
    }

    getUserImageURL(userProfile: UserProfile) {
        return new Promise<string>((resolve, reject) => {
            if (!userProfile?.relationships?.field_imagen?.data ||
                !userProfile?.relationships?.field_imagen?.links?.related?.href) {
                resolve(null);
            } else {
                this.http.get(userProfile.relationships.field_imagen.links.related.href).subscribe({
                    next: (response: any) => {
                        if (response.data) {
                            let baseUrl = new URL(environment.drupal.apiBaseUrl);
                            baseUrl.pathname = new URL(response.data.attributes.uri.url, environment.drupal.apiBaseUrl).pathname;
                            let url = baseUrl.toString();
                            resolve(url);
                        } else {
                            resolve(null);
                        }
                    },
                    error: (err) => {
                        reject(err);
                    }
                });
            }
        });
    }

    updateUserProfile(userProfile: UserProfile) {
        return new Promise<UserProfile>((resolve, reject) => {
            const data = {
                data: userProfile
            };
            const headers = {
                'Content-Type': 'application/vnd.api+json'
            };
            this.http.patch(`${environment.drupal.apiBaseUrl}/jsonapi/user/user/${userProfile.id}`, data, { headers }).subscribe({
                next: (response: any) => {
                    resolve(response.data as UserProfile);
                },
                error: (err) => {
                    reject(err);
                }
            });
        });
    }

    uploadUserImage(userProfile: UserProfile, file: File) {
        return new Promise<UserImage>((resolve, reject) => {
            const fileName = `${userProfile.id}_${file.name}`;

            const reader = new FileReader();
            reader.onload = () => {
                const formData = reader.result as ArrayBuffer;

                const headers = {
                    'Accept': 'application/vnd.api+json',
                    'Content-Type': 'application/octet-stream',
                    'Content-Disposition': `file; filename="${fileName}"`
                }

                this.http.post(`${environment.drupal.apiBaseUrl}/jsonapi/user/user/${userProfile.id}/field_imagen`, formData, { headers }).subscribe({
                    next: (response: any) => {
                        let baseUrl = new URL(environment.drupal.apiBaseUrl);
                        baseUrl.pathname = new URL(response.data.attributes.uri.url, environment.drupal.apiBaseUrl).pathname;
                        let url = baseUrl.toString();
                        const image = {
                            id: response.data.id,
                            type: response.data.type,
                            url: url
                        };
                        resolve(image);
                    },
                    error: (err) => {
                        reject(err);
                    }
                });
            };

            reader.onerror = reject;
            reader.readAsArrayBuffer(file);
        });
    }
}